const publicUrl = process.env.PUBLIC_URL || "";

const projects = [
  {
    title: "BFA",
    description:
      "Structured youth football coaching for players from U6 to U16 at Brussels Football Academy.",
    tags: ["Football academy", "Youth coaching", "U6–U16"],
    image: `${publicUrl}/projects/bfa.ait-sidi-said.work.png`,
    imageAlt: "Brussels Football Academy website preview",
    tone: "blue",
    links: {
      demo: "https://bfa.ait-sidi-said.work/",
      github: null
    }
  },
  {
    title: "Zulu Nawfel",
    description:
      "An immersive artist website showcasing releases, visuals and the story of a Casablanca DJ and producer.",
    tags: ["Artist portfolio", "Music releases", "Immersive design"],
    image: `${publicUrl}/projects/zulunawfel.ait-sidi-said.work.png`,
    imageAlt: "Zulu Nawfel artist website screenshot",
    imagePosition: "left top",
    tone: "blue",
    links: {
      demo: "https://zulunawfel.ait-sidi-said.work/",
      github: null
    }
  },
  {
    title: "TTinette",
    description:
      "An electric scooter storefront designed to make model discovery, comparison and purchasing straightforward.",
    tags: ["E-commerce", "Product comparison", "Electric mobility"],
    image: `${publicUrl}/projects/ttinette.ait-sidi-said.work.png`,
    imageAlt: "TTinette electric scooter website screenshot",
    tone: "amber",
    links: {
      demo: "https://ttinette.ait-sidi-said.work/",
      github: null
    }
  },
  {
    title: "Waxapp Web App",
    description:
      "Gives small businesses one place to track leads, orders and customer follow-ups on WhatsApp.",
    tags: ["Lead tracking", "Order follow-up", "Customer retention"],
    image: `${publicUrl}/projects/whatsastore-preview.png`,
    imageAlt: "Waxapp application screenshot",
    tone: "green",
    links: {
      demo: "https://whatsastore.online/",
      github: null
    }
  },
  {
    title: "Waxapp Helper",
    description:
      "Helps sellers move faster by syncing contacts and streamlining WhatsApp sales follow-up.",
    tags: ["Workflow speed", "Contact sync", "Sales support"],
    image: `${publicUrl}/projects/whatsastore-helper-preview.png`,
    imageAlt: "Waxapp Helper Chrome extension screenshot",
    tone: "green",
    links: {
      demo: "https://chromewebstore.google.com/detail/whatsastore-helper/nnpbmffehjadfimgaolcegiekfekngoi?hl=fr&utm_source=ext_sidebar",
      github: null,
      demoLabel: "Chrome Web Store"
    }
  },
  {
    title: "Sketchstash",
    description:
      "Keeps commands, notes and technical snippets easy to save, find and reuse later.",
    tags: ["Knowledge capture", "Fast recall", "Developer notes"],
    image: `${publicUrl}/projects/sketchstash-preview.png`,
    imageAlt: "Sketchstash application screenshot",
    tone: "blue",
    links: {
      demo: "https://sketchstash.online/",
      github: "https://github.com/hamza-topo/boxnot"
    }
  },
  {
    title: "NawarGlam",
    description:
      "Improves product discovery and makes WhatsApp-first ordering feel simple for shoppers.",
    tags: ["Product discovery", "WhatsApp ordering", "Shoppers"],
    image: `${publicUrl}/projects/nawarglam-preview.png`,
    imageAlt: "NawarGlam website screenshot",
    tone: "pink",
    links: {
      demo: "https://nawarglam.com/",
      github: null
    }
  },
  {
    title: "PetMingle",
    description:
      "A concept for pet discovery, matching and adoption-style browsing flows.",
    tags: ["Discovery", "Matching", "Coming soon"],
    status: "Coming soon",
    image: null,
    imageAlt: "PetMingle coming soon preview",
    tone: "amber",
    links: {
      demo: null,
      github: null
    }
  }
];

export default projects;
